var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingTopLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 630,
    height: 200,
    viewBox: "0 0 630 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 158.602,
    cy: 31.2768,
    rx: 19.8252,
    ry: 19.8239,
    fill: "url(#paint0_linear_140_221)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.88722e-05 11.4529H122.476V45.3915H39.569L39.569 90.642H122.476V126.466H39.569L39.569 200L0 189.208L3.88722e-05 11.4529Z",
    fill: "url(#paint1_linear_140_221)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.247 60.3528H387.895V135.6H387.907C387.907 138.907 388.539 142.182 389.768 145.237C390.998 148.293 392.799 151.069 395.07 153.407C397.341 155.746 400.038 157.601 403.005 158.867C405.973 160.132 409.153 160.784 412.365 160.784C415.577 160.784 418.757 160.132 421.725 158.867C424.692 157.601 427.388 155.746 429.66 153.407C431.931 151.069 433.732 148.293 434.961 145.237C436.191 142.182 436.823 138.907 436.823 135.6H436.837V60.3529H474.484V135.601H474.483C474.483 144 472.877 152.317 469.755 160.077C466.633 167.837 462.058 174.888 456.289 180.827C450.521 186.766 443.673 191.477 436.137 194.692C428.6 197.906 420.522 199.561 412.365 199.561C404.207 199.561 396.13 197.906 388.593 194.692C381.057 191.477 374.209 186.766 368.441 180.827C362.672 174.888 358.097 167.837 354.975 160.077C351.853 152.317 350.246 143.999 350.246 135.6H350.247V60.3528Z",
    fill: "url(#paint2_linear_140_221)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.425 60.3528L178.425 199.561L138.775 199.561L138.775 71.6634L178.425 60.3528Z",
    fill: "url(#paint3_linear_140_221)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.355 68.0167L232.355 0L194.729 10.5249V129.538L194.73 129.537C194.729 129.659 194.729 129.781 194.729 129.903C194.729 168.374 225.893 199.561 264.337 199.561C302.781 199.561 333.946 168.374 333.946 129.903C333.946 91.432 302.781 60.2452 264.337 60.2452C252.807 60.2452 241.931 63.0507 232.355 68.0167ZM296.318 129.903C296.318 147.578 281.999 161.908 264.336 161.908C246.673 161.908 232.354 147.578 232.354 129.903C232.354 112.227 246.673 97.8978 264.336 97.8978C281.999 97.8978 296.318 112.227 296.318 129.903Z",
    fill: "url(#paint4_linear_140_221)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M592.374 68.0167V0L630 10.5249V199.561H592.374V191.789C582.798 196.755 571.922 199.561 560.392 199.561C521.948 199.561 490.783 168.374 490.783 129.903C490.783 91.432 521.948 60.2452 560.392 60.2452C571.922 60.2452 582.798 63.0507 592.374 68.0167ZM592.374 130.146V129.659C592.243 112.095 577.975 97.8978 560.393 97.8978C542.729 97.8978 528.41 112.227 528.41 129.903C528.41 147.578 542.729 161.908 560.393 161.908C577.975 161.908 592.243 147.71 592.374 130.146Z",
    fill: "url(#paint5_linear_140_221)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_140_221",
    x1: 128.392,
    y1: 28.7988,
    x2: 148.653,
    y2: 22.6761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9170F2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E1FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_140_221",
    x1: -32.0769,
    y1: 93.9423,
    x2: 33.6901,
    y2: 81.0337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9170F2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E1FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_140_221",
    x1: 317.708,
    y1: 121.256,
    x2: 382.295,
    y2: 103.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9170F2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E1FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_140_221",
    x1: 161.078,
    y1: 23.8936,
    x2: 199.826,
    y2: 60.4189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9170F2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E1FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_140_221",
    x1: 158.267,
    y1: 87.3077,
    x2: 232.601,
    y2: 71.6386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9170F2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E1FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_140_221",
    x1: 454.322,
    y1: 87.3077,
    x2: 528.655,
    y2: 71.6386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9170F2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E1FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingTopLogo);
export default __webpack_public_path__ + "static/media/landing_top_logo.ca9a99caa16deec75291b205ed5ca66b.svg";
export { ForwardRef as ReactComponent };